<div class="row">
  <h3>
    {{ "account.email-change.title" | translate }}
  </h3>
</div>
<div class="row disclaimer">
  <div class="caption">
    <small>
      {{ "account.email-change.disclaimer" | translate }}
    </small>
  </div>
</div>
<form [formGroup]="emailForm" (ngSubmit)="submitEmailChange()">
  <div class="row input email">
    <div class="content">
      <input
        type="email"
        class="input"
        [placeholder]="'account.email-change.form.email' | translate"
        [class.error]="emailForm.errors || (emailForm.get('email')?.errors && !emailForm.get('email')?.errors.required)"
        formControlName="email"
      />
    </div>
  </div>
  <div class="row controls" *ngIf="emailForm.valid">
    <button type="submit" class="btn" [disabled]="!emailForm.valid">
      <span>
        {{ "account.email-change.controls.save" | translate }}
      </span>
    </button>
  </div>
  <div class="row form-error">
    <div class="caption" *ngIf="emailForm">
      <small *ngIf="emailForm.errors">
        {{
          "account.email-change.form.errors." +
          (emailForm.errors | keyvalue)[0].key | translate
        }}
      </small>
      <small *ngIf="emailForm.get('email')?.errors && !emailForm.get('email')?.errors.required">
        {{
          "account.email-change.form.errors." +
          (emailForm.get('email').errors | keyvalue)[0].key | translate
        }}
      </small>
    </div>
  </div>
</form>
